import type * as Types from 'app/types/graphql';

export type ThemePageEdgeSelectFragment = Pick<Types.ThemePageEdge, 'cursor'> & {
  node?: Types.Maybe<
    Pick<
      Types.ThemePage,
      | 'id'
      | 'name'
      | 'type'
      | 'default'
      | 'isGlobal'
      | 'status'
      | 'updatedAt'
      | 'publishedAt'
      | 'handle'
    > & {
      metafields?: Types.Maybe<
        Array<
          Types.Maybe<Pick<Types.ThemePageMeta, 'createdAt' | 'id' | 'key' | 'updatedAt' | 'value'>>
        >
      >;
      parent?: Types.Maybe<Pick<Types.ThemePage, 'id' | 'name' | 'type' | 'status' | 'default'>>;
    }
  >;
};

export type ThemePageMetaSelectFragment = Pick<
  Types.ThemePageMeta,
  'createdAt' | 'id' | 'key' | 'updatedAt' | 'value'
>;

export type ThemePageParentSelectFragment = Pick<
  Types.ThemePage,
  'id' | 'name' | 'type' | 'status' | 'default'
>;

export type ThemePageSelectFragment = Pick<
  Types.ThemePage,
  | 'id'
  | 'name'
  | 'type'
  | 'default'
  | 'isGlobal'
  | 'status'
  | 'updatedAt'
  | 'publishedAt'
  | 'handle'
> & {
  metafields?: Types.Maybe<
    Array<
      Types.Maybe<Pick<Types.ThemePageMeta, 'createdAt' | 'id' | 'key' | 'updatedAt' | 'value'>>
    >
  >;
  parent?: Types.Maybe<Pick<Types.ThemePage, 'id' | 'name' | 'type' | 'status' | 'default'>>;
};

export const ThemePageMetaSelectFragmentDoc = `
    fragment ThemePageMetaSelect on ThemePageMeta {
  createdAt
  id
  key
  updatedAt
  value
}
    `;
export const ThemePageParentSelectFragmentDoc = `
    fragment ThemePageParentSelect on ThemePage {
  id
  name
  type
  status
  default
}
    `;
export const ThemePageSelectFragmentDoc = `
    fragment ThemePageSelect on ThemePage {
  id
  name
  type
  default
  isGlobal
  status
  updatedAt
  publishedAt
  metafields {
    ...ThemePageMetaSelect
  }
  parent {
    ...ThemePageParentSelect
  }
  handle
}
    `;
export const ThemePageEdgeSelectFragmentDoc = `
    fragment ThemePageEdgeSelect on ThemePageEdge {
  cursor
  node {
    ...ThemePageSelect
  }
}
    `;
